import * as React from "react";
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { auth } from "../firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import MyToast from './MyToast';
import MySpinner from './MySpinner';
import './Login.css'

const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const state = location.state;
    const msg = state?.msg;
    const returnUrl = state?.returnUrl;

    const [loginData, setLoginData] = React.useState({});
    const [inProgress, setInProgress] = React.useState(false);
    const [showPassword, setShowPassword] = React.useState(false);
    const [openToast, setOpenToast] = React.useState({
        open: false,
        msg: '',
        severity: ''
    });

    const handleChange = e => {
        setLoginData({ ...loginData, [e.target.name]: e.target.value });
    }

    React.useEffect(() => {
        if (msg) {
            setOpenToast({
                open: true,
                msg: msg,
                severity: 'info'
            });
        }
    }, []);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Vérification des paramètres requis
        let { email, password } = loginData;
        if (!email || !password) {
            setOpenToast({
                open: true,
                msg: "Veuillez renseigner votre adresse email et mot de passe",
                severity: "error"
            });
            return;
        }

        try {
            setInProgress(true);
            const userCredential = await signInWithEmailAndPassword(auth, email, password);

            setOpenToast({
                open: true,
                msg: "Connexion réussie",
                severity: "success"
            });

            setInProgress(false);

            if (returnUrl) {
                navigate(returnUrl);
            } else {
                navigate('/accueil');
            }

        } catch (error) {
            setInProgress(false);
            const errorCode = error?.code;

            const errorMessages = {
                'auth/wrong-password': "Le mot de passe est invalide",
                'auth/user-not-found': "Le compte spécifié est introuvable",
                'auth/network-request-failed': "Vérifiez votre connexion internet",
                'auth/too-many-requests': "Vous avez effectué trop de tentatives. Pour des raisons de sécurité, vous devez modifier votre mot de passe ou vous connecter plus tard"
            };

            setOpenToast({
                open: true,
                msg: errorMessages[errorCode] || "Une erreur s'est produite, veuillez réessayer ultérieurement",
                severity: "error"
            });
        }
    };

    return (
        <div className="ml-container">
            <div className="ml-login-wrapper">
                <div className="ml-card">
                    <div className="ml-card-header">
                        <h1 className="ml-title">Connexion</h1>
                        <div className="ml-brand-logo">
                            {/* Logo optionnel */}
                        </div>
                    </div>

                    <div className="ml-card-body">
                        <form onSubmit={handleSubmit} className="ml-form">
                            <div className="ml-form-group">
                                <label className="ml-label" htmlFor="email">Adresse e-mail</label>
                                <div className="ml-input-container">
                                    <span className="ml-input-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6Z" />
                                            <path d="M22 6L12 13L2 6" />
                                        </svg>
                                    </span>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        className="ml-input"
                                        placeholder="exemple@email.com"
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="ml-form-group">
                                <div className="ml-label-container">
                                    <label className="ml-label" htmlFor="password">Mot de passe</label>
                                    <NavLink className="ml-forgot-link" to="/mot-de-passe-oublie">
                                        Mot de passe oublié?
                                    </NavLink>
                                </div>
                                <div className="ml-input-container">
                                    <span className="ml-input-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                        </svg>
                                    </span>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        id="password"
                                        name="password"
                                        className="ml-input"
                                        placeholder="••••••••"
                                        onChange={handleChange}
                                        required
                                    />
                                    <button
                                        type="button"
                                        className="ml-password-toggle"
                                        onClick={togglePasswordVisibility}
                                    >
                                        {showPassword ? (
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                                                <circle cx="12" cy="12" r="3" />
                                                <line x1="2" y1="2" x2="22" y2="22" />
                                            </svg>
                                        ) : (
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                                                <circle cx="12" cy="12" r="3" />
                                            </svg>
                                        )}
                                    </button>
                                </div>
                            </div>

                            <button
                                type="submit"
                                className="ml-button-primary"
                                disabled={inProgress}
                            >
                                {inProgress ? (
                                    <span className="ml-spinner-small"></span>
                                ) : "Se connecter"}
                            </button>
                        </form>
                    </div>

                    <div className="ml-card-footer">
                        <p className="ml-signup-text">
                            Pas encore de compte? <NavLink className="ml-signup-link" to="/inscription">Inscription</NavLink>
                        </p>


                    </div>
                </div>
            </div>

            <MyToast
                openToast={openToast}
                setOpenToast={setOpenToast}
            />

            {inProgress && <MySpinner loading={inProgress} />}
        </div>
    );
};

export default Login;